import React, { useContext } from 'react';
import { Col, Row } from 'antd';

import ComplianceContext from '@totem/components/surveyV2/complianceSummary/complianceContext';
import PolicyCompliance from '@totem/components/surveyV2/complianceSummary/policyCompliance/policyCompliance';
import PortfolioHealthComplianceSummary from '@totem/components/surveyV2/complianceSummary/portfolioHealthOverview/portfolioHealthComplianceSummary';
import IBCard from '@totem/components/ui_components/antDesignOverrides/IBCard';
import { isNotNull } from '@totem/utilities/common';

const ComplianceSection = () => {
  const { data } = useContext(ComplianceContext);

  const showCompliance = isNotNull(data);

  return (
    <>
      {showCompliance && (
        <IBCard title={'Compliance'} isCovered>
          <Row gutter={16}>
            <Col span={12}>
              <PortfolioHealthComplianceSummary />
            </Col>
            <Col span={12}>
              <PolicyCompliance />
            </Col>
          </Row>
        </IBCard>
      )}
    </>
  );
};

export default ComplianceSection;
